import {
    get,
    isEqual
} from 'lodash';
import { createSelector } from 'reselect';
import {
    UPDATE_PASSWORD_LOAD,
    UPDATE_PASSWORD_FAILURE,
    UPDATE_PASSWORD_SUCCESS,
    UPDATE_PASSWORD_CLEAR_SESSIONS_SUCCESS,
    UPDATE_PASSWORD_CLEAR_SESSIONS_LOAD,
    UPDATE_PASSWORD_CLEAR_SESSIONS_FAILURE
} from './updatePasswordActions';
import { getViewStateByName } from '../appViewStates';

export default function reducer(state = {}, action = {}) {
    let newState;

    switch (action.type) {
        case UPDATE_PASSWORD_LOAD:
            newState = {
                ...state,
                loading: true,
                updatePasswordFeedback: null
            };

            return isEqual(state, newState) ? state : newState;

        case UPDATE_PASSWORD_FAILURE:
            newState = {
                ...state,
                loading: false,
                updatePasswordFeedback: action.error
            };

            return isEqual(state, newState) ? state : newState;

        case UPDATE_PASSWORD_SUCCESS:
            newState = {
                ...state,
                loading: false,
                updatePasswordFeedback: {
                    isResponseSuccess: true,
                    message: 'Password successfully updated.'
                }
            };

            return isEqual(state, newState) ? state : newState;

        case UPDATE_PASSWORD_CLEAR_SESSIONS_LOAD:
            newState = {
                ...state,
                clearLoading: true,
                clearError: null
            };

            return isEqual(state, newState) ? state : newState;

        case UPDATE_PASSWORD_CLEAR_SESSIONS_FAILURE:
            newState = {
                ...state,
                clearLoading: false,
                clearError: action.error
            };

            return isEqual(state, newState) ? state : newState;

        case UPDATE_PASSWORD_CLEAR_SESSIONS_SUCCESS:
            newState = {
                ...state,
                clearLoading: false
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getUpdatePasswordViewState = createSelector(
    (state) => state,
    (state) => getViewStateByName(state, 'updatePassword')
);

export const getUpdatePasswordFeedback = createSelector(
    getUpdatePasswordViewState,
    (viewState) => get(viewState, 'updatePasswordFeedback')
);

export const getIsUpdatePasswordFeedbackSuccessful = createSelector(
    getUpdatePasswordFeedback,
    (feedback) => get(feedback, 'isResponseSuccess')
);

export const getUpdatePasswordFeedbackMessage = createSelector(
    getUpdatePasswordFeedback,
    (feedback) => get(feedback, 'message')
);

export const getIsLoading = createSelector(
    getUpdatePasswordViewState,
    (viewState) => get(viewState, 'loading')
);

export const getIsClearLoading = createSelector(
    getUpdatePasswordViewState,
    (viewState) => get(viewState, 'clearLoading')
);

export const getClearError = createSelector(
    getUpdatePasswordViewState,
    (viewState) => get(viewState, 'clearError')
);

export const getClearErrorMessage = createSelector(
    getClearError,
    (error) => get(error, 'message')
);
